import { useEffect, useState } from "react"
import { getGradeDetails, deleteGradeVariation, deleteGradeItem } from "../../../api"
import { mountApiUrl } from "../../../api/utils"
import config from "../../../environments/generated.config"
import { useBasket, useLoading, useResponsive, getHasBasketContent } from "../../../providers"
import { Layout } from "./Layout"

export const Grade = ({ item, user }) => {
  const [collapse, setCollapse] = useState(false)
  const { isMobile } = useResponsive()

  const [details, setDetails] = useState([])

  const { basketReload } = useBasket()

  const { setLoading } = useLoading()

  const getDetails = async () => {
    try {
      setLoading(true)
      const data = await getGradeDetails(item.produto)
      data.SUCCESS ? setDetails(data.RESULT) : setCollapse(false)
      setLoading(false)
    } catch (error) {
      setCollapse(false)
      setLoading(false)
    }
  }

  const editUrl = mountApiUrl(config.urls.home, config.urls.edit_grade, {
    product_id: item.produto,
  })

  const [editRoute] = useState(editUrl)

  const deleteVariation = async (OOPCOD) => {
    await deleteGradeVariation(item.produto, OOPCOD)
    await basketReload()
    await getDetails()
    await getHasBasketContent()
  }

  const toggleCollapse = () => setCollapse(!collapse)

  useEffect(() => {
    collapse && getDetails()
  }, [collapse])

  const handleDelete = async () => {
    await deleteGradeItem(item.produto, user.cond_pag)
    await basketReload()
    await getHasBasketContent()
  }

  const layoutProps = {
    item,
    editRoute,
    collapse,
    details,
    handleDelete,
    deleteVariation,
    toggleCollapse,
    isMobile,
  }

  return <Layout {...layoutProps} />
}
